import React, { useEffect, useState } from "react";
import "./style.scss";
import { Table } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useBatchQuoteInfo } from "../../../hooks/useOrderBatches";
import Button from "../../../common/Button";

const BatchQuoteDetails = () => {
  const [batchList, setBatchList] = useState([]);
  const [currency, setCurrency] = useState();
  const [totalAmountToPay, setTotalAmountToPay] = useState();
  const navigate = useNavigate();
  const params = useParams();
  const columns = [
    {
      title: "Sku Name",
      key: "skuname",
      align: "center",
      dataIndex: "skuname",
      render: (_, record, index) => {
        return <div>{record?.skuName}</div>;
      },
    },
    {
      title: "Title",
      key: "title",
      align: "center",
      dataIndex: "title",
      render: (_, record) => {
        return <div>{record?.title}</div>;
      },
    },
    {
      title: "Quantity",
      key: "quantity",
      align: "center",
      dataIndex: "quantity",
      render: (_, record) => {
        return <div>{record?.qty}</div>;
      },
    },
    {
      title: "Curreny",
      key: "currency",
      align: "center",
      dataIndex: "action",
      render: (_, record) => {
        return <div>{record?.currency}</div>;
      },
    },
    {
      title: "Price/Unit",
      key: "pricePerUnit",
      align: "center",
      dataIndex: "unit_amount",
      render: (_, record) => {
        return <div>{record?.unit_amount}</div>;
      },
    },
    {
      title: "Total Amount",
      key: "totalAmount",
      align: "center",
      dataIndex: "total",
      render: (_, record) => {
        return <div>{(record?.unit_amount * record?.qty).toFixed(2)}</div>;
      },
    },
  ];

  const onSuccessGetAllBatches = (res) => {
    if (res?.status === 200) {
      const quoteItems = res?.data?.data?.quoteItems || [];
      setBatchList(quoteItems);

      if (quoteItems.length > 0) {
        setCurrency(quoteItems[0]?.currency);
      }

      const totalAmount = quoteItems.reduce((total, item) => {
        return total + (item?.qty || 0) * (item?.unit_amount || 0);
      }, 0);

      setTotalAmountToPay(totalAmount);
    }
  };

  const onErrorGetAllBatches = (err) => {
    console.log(err);
  };
  const { data, refetch: getAllBatches } = useBatchQuoteInfo(
    "batch_Info_list",
    params?.batchId,
    onSuccessGetAllBatches,
    onErrorGetAllBatches
  );
  return (
    <div className="quote_batch_list">
      <div className="quote_batch_list_content">
        <div className="list_wrapper">
          <Table
            columns={columns}
            dataSource={batchList}
            scroll={{
              // x: 2100,
              y: `100%`,
            }}
            className="main_table"
            pagination={false}
          />
        </div>
        <div className="pagination_wrapper">
          <div className="amount_wrapper">
            <div className="heading">Total Amount to Pay :</div>
            <div className="amount">
              {currency} {totalAmountToPay?.toFixed(2)}
            </div>
          </div>
          <Button
            text="Next"
            height="50px"
            width="195px"
            handleClick={() =>
              navigate(`/billing-details/${params?.batchId}`, {
                state: {
                  totalAmount: totalAmountToPay?.toFixed(2),
                  currency: currency,
                },
              })
            }
          />
        </div>
      </div>
    </div>
  );
};
export default BatchQuoteDetails;
